// Explicit document registry barrel.
import { blogDocuments } from './blog';
import { featureDocuments } from './features';
import { gameDocuments } from './games';
import { reportDocuments } from './reports';
import { termsDocument } from './legal/terms';
export const documents = [
    ...gameDocuments,
    ...featureDocuments,
    ...reportDocuments,
    ...blogDocuments,
    termsDocument,
];
export * from './blog';
export * from './features';
export * from './games';
export * from './legal/terms';
export * from './reports';
//# sourceMappingURL=index.js.map